import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { UserCheck } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

export const FriendlyMatchGlobalNotification = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [matchFound, setMatchFound] = useState<any>(null);

  const API_URL = import.meta.env.VITE_API_URL || 'https://techtennis-api.vercel.app';
  const getAuthHeader = () => {
    const t = localStorage.getItem('tt_auth_token');
    return t ? { 'Authorization': `Bearer ${t}` } : {} as HeadersInit;
  };

  useEffect(() => {
    const checkRadar = async () => {
      const isActive = localStorage.getItem('tt_radar_amistoso_active') === 'true';
      const hasMatch = localStorage.getItem('tt_radar_amistoso_match');
      
      if (isActive && !hasMatch && !matchFound) {
        // Obter do localStorage os dados para a busca
        const radius = localStorage.getItem('tt_fm_radius') || '10';
        const myCategory = localStorage.getItem('tt_fm_mycat') || '';
        const oppCats = localStorage.getItem('tt_fm_oppcats') || '[]';
        const myAge = localStorage.getItem('tt_fm_myage') || '';
        const age = localStorage.getItem('tt_fm_ages') || '[]';
        
        // Pega location atual. Ideal seria persistir no activation.
        // Vamos usar getCurrentPosition sem alert pra ser silencioso no background.
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(async (pos) => {
            try {
              const latParam = `lat=${pos.coords.latitude}&lng=${pos.coords.longitude}&radius=${radius}&myCategory=${myCategory}&opponentCategories=${oppCats}&myAge=${encodeURIComponent(myAge)}&age=${encodeURIComponent(age)}`;
              const res = await fetch(`${API_URL}/api/friendly-match/search?${latParam}`, { headers: getAuthHeader() });
              if (res.ok) {
                const data = await res.json();
                if (data && data.userId) {
                  const realMatch = {
                    userId: data.userId,
                    name: data.name,
                    level: data.myCategory,
                    distance: `${data.distance ? data.distance.toFixed(1) : '< 1'}km`,
                    court: data.court
                  };
                  setMatchFound(realMatch);
                  localStorage.setItem('tt_radar_amistoso_match', JSON.stringify(realMatch));
                }
              }
            } catch(e) {}
          }, () => {}, { timeout: 5000 });
        }
      } else if (hasMatch && !matchFound) {
        setMatchFound(JSON.parse(hasMatch));
      } else if (!isActive && matchFound) {
        setMatchFound(null);
      }
    };

    const interval = setInterval(checkRadar, 5000);
    return () => clearInterval(interval);
  }, [matchFound]);

  // If the user is ALREADY on the friendly match screen, don't show the global popup
  if (!matchFound || location.pathname === '/friendly-match') return null;

  return (
    <div style={{ position: 'fixed', bottom: '24px', left: '24px', zIndex: 9999 }}>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0, x: -50, scale: 0.9 }}
          animate={{ opacity: 1, x: 0, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          onClick={() => {
            navigate('/friendly-match');
          }}
          style={{
            background: 'var(--bg-panel)',
            border: '2px solid #3A8E58',
            padding: '16px 24px',
            borderRadius: '16px',
            boxShadow: '0 10px 40px rgba(0,0,0,0.5), 0 0 20px rgba(58, 142, 88, 0.3)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}
        >
          <div style={{
            background: 'rgba(58, 142, 88, 0.1)',
            width: '48px', height: '48px',
            borderRadius: '50%',
            display: 'flex', justifyContent: 'center', alignItems: 'center'
          }}>
            <UserCheck size={24} color="#3A8E58" />
          </div>
          <div>
            <h4 style={{ color: 'white', margin: '0 0 4px 0', fontSize: '16px' }}>
              Adversário Encontrado!
            </h4>
            <p style={{ color: 'var(--text-secondary)', margin: 0, fontSize: '13px' }}>
              {matchFound.name} está a {matchFound.distance}. Clique aqui!
            </p>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
